const context = "colaborador";
const abrev = "colab";

export default [
    {
        path: '/usuario/gerenciar-usuario',
        name: 'usuario-gerenciar',
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/colaborador/gerenciar-usuario/GerenciarUsuarioRoute.vue"),
        children: [
            {
                path: "list",
                name: "usuario-gerenciar-list",
                meta: { contexto: context, abrev: abrev },
                component: () => import("@/components/colaborador/gerenciar-usuario/GerenciarUsuarioList.vue"),
                children:[
                    {
                        path: 'new',
                        name: 'usuario-gerenciar-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/colaborador/gerenciar-usuario/GerenciarUsuarioManager.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'usuario-gerenciar-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/colaborador/gerenciar-usuario/GerenciarUsuarioManager.vue')
                    },
                ]
            },
        ]
    },
    {
        path: "/usuario/acessos-e-permissoes",
        name: "usuario-acessos-permissoes",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/colaborador/acesso-permissao/AcessoPermissaoList.vue"),
        children: [
            {
                path: "new",
                name: "usuario-acessos-permissoes-new",
                meta: { contexto: context, abrev: abrev },
                component: () => import("@/components/colaborador/acesso-permissao/AcessoPermissaoManager.vue"),
            },
            {
                path: "edit/:id",
                name: "usuario-acessos-permissoes-edit",
                meta: { contexto: context, abrev: abrev },
                component: () => import("@/components/colaborador/acesso-permissao/AcessoPermissaoManager.vue"),
            },
        ]
    },
    {
        path: "/conta/vinculos-usuarios",
        name: "usuario-vinculos",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/colaborador/VinculoUsuarioList.vue"),
        children: [
            {
                path: "edit/:id",
                name: "usuario-vinculos-edit",
                meta: { contexto: context, abrev: abrev },
                component: () => import("@/components/colaborador/VinculoUsuarioManage.vue"),
            },
        ]
    },
    {
        path: "/usuario/auditorias-dados",
        name: "usuario-auditorias-dados",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/colaborador/AuditoriasDados.vue"),
    },
    {
        path: "/usuario/auditorias-acesso",
        name: "usuario-auditorias-acesso",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/colaborador/AuditoriasAcesso.vue"),
    },
    {
        path: "/config/controleaparelhos",
        name: "usuario-controle-aparelhos",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/colaborador/Aparelhos.vue"),
    },
    {
        path: '/colaborador/cargo',
        name: 'usuario-cargo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/colaborador/cargo/Cargo.vue'),
        children: [
            {
                path: 'list',
                name: 'usuario-cargo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/colaborador/cargo/CargoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'usuario-cargo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/colaborador/cargo/CargoManager.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'usuario-cargo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/colaborador/cargo/CargoManager.vue')
                    },
                ]
            },
        ]
    },
];
